module.exports = "/assets/37d17a235a9d8ed173d904c88fcf472b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/9U.png
// module id = 2303
// module chunks = 0